module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/4-dd17ed1535d07a4a259d5d6b3822e77d.svg";